// handle fund select
function handleSectorSelect() {
  const currentSector = document.querySelector('.hero-banner .sector-select .current-sector');
  const currentSectorText = document.querySelector('.hero-banner .sector-select .current-sector .current-sector-title');
  const arrow = document.querySelector('.hero-banner .sector-select .select-arrow');
  const sectorList = document.querySelector('.hero-banner .sector-select .sector-listing');
  const breakpoint = window.matchMedia('(min-width: 1024px)');
  const sectorOptions = document.querySelectorAll('.hero-banner  .sector-listing .sector-item a');
  const goToSectorBtn = document.querySelector('.hero-banner #go-to-sector');

  if (goToSectorBtn) {
    goToSectorBtn.addEventListener('click', (e) => {
      if (!goToSectorBtn.getAttribute('href')) {
        e.preventDefault();
      }
    });
  }

  if (currentSector && sectorList) {
    currentSector.addEventListener('click', () => {
      currentSector.classList.toggle('active');
      arrow.classList.toggle('active');
      sectorList.classList.toggle('open');
    });
  }

  sectorOptions.forEach((option) => {
    option.addEventListener('click', (e) => {
      if (breakpoint.matches) {
        e.preventDefault();
        currentSector.classList.remove('active');
        arrow.classList.remove('active');
        sectorList.classList.remove('open');
        const optionUrl = option.getAttribute('href');
        if (optionUrl && goToSectorBtn) {
          goToSectorBtn.setAttribute('href', optionUrl);
          currentSectorText.innerText = option.innerText;
        }
      }
    });
  });
}

window.addEventListener('DOMContentLoaded', () => {
  const heroBanner = document.querySelector('.hero-banner');
  if (!heroBanner) return;
  handleSectorSelect();
});
